module.exports = __webpack_public_path__ + "img/alach_yes.8c4af9fb.png";